module.exports = __webpack_public_path__ + "img/agent1.b40d6b09.png";